<template>
  <div class="footer-container">
    <div class="footer-body">
      <div>
        © 2021 - {{ year }} nicetomeetor
      </div>
      <social-media />
    </div>
  </div>
</template>

<script>
import SocialMedia from "./SocialMedia/SocialMedia";

export default {
  name: "Footer",
  data() {
    return {
      year: (new Date).getFullYear()
    }
  },
  components: {
    SocialMedia
  }
}
</script>

<style scoped>
.footer-body {
  padding: 20px;
  font-weight: bold;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
